<template>
  <div class="format-information">
    <div class="voucher-chip-and-logo">
      <div class="voucher-chip" :class="previewModeClass">
        <span>Voucher de R$ {{ offer.benefits.value }} no</span>
      </div>
      <img :src="getImageUrl" alt="ícone do voucher" :width="getWidthFromType" :height="previewMode || isMobile ? '30px' : '36px'" />
    </div>
    <span v-if="!isMobile" class="maximum-per-client-text"><strong>Máx. CPF: </strong>{{ offer.trigger_rules.maximum_per_client }}</span>
  </div>
</template>

<script>
export default {
  name: 'VoucherDigitalMechanic',
  props: {
    offer: {
      type: Object,
      required: true,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    benefit() {
      return this.offer.benefits.type.toLowerCase()
    },
    getImageUrl() {
      const size = this.previewMode || this.isMobile ? '30' : '36'
      return `https://storage.googleapis.com/new-cdn.mercafacil.com/industria/front/mercapromo/benefits-chip/${this.benefit}-${size}.svg`
    },
    previewModeClass() {
      return [
        {
          'bg-white': this.previewMode,
          'bg-cinza-l90': !this.previewMode,
          'font-size-12': this.previewMode || this.isMobile,
          'font-size-16': !this.previewMode && !this.isMobile,
        },
      ]
    },
    getWidthFromType() {
      switch (this.benefit) {
        case 'spotify':
        case 'tinder':
          return '76px'
        case 'uber':
        case 'ifood':
        default:
          return '58px'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.format-information {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;

  @media screen and (max-width: $xs-breakpoint) {
    align-items: center;
    gap: 8px;
  }

  .voucher-chip-and-logo {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      border-radius: 16px;
      margin-left: -8px;
    }

    .voucher-chip {
      padding: 6px 12px;
      border-radius: 16px;
      border-top-right-radius: unset;
      border-bottom-right-radius: unset;
      font-weight: bold;
      color: $cinza-d20;
      white-space: nowrap;
      width: fit-content;
      user-select: none;
    }

    .font-size-12 {
      font-size: 12px;
    }

    .font-size-16 {
      font-size: 16px;
    }

    .bg-white {
      background-color: white;
    }

    .bg-cinza-l90 {
      background-color: $cinza-l90;
    }
  }

  .maximum-per-client-text {
    color: $cinza-0;
    font-size: 14px;
    margin-right: 6px;
  }
}
</style>
